import { render, staticRenderFns } from "./OrderSubmissionStage.vue?vue&type=template&id=2067e78e&"
import script from "./OrderSubmissionStage.vue?vue&type=script&lang=js&"
export * from "./OrderSubmissionStage.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubmissionStage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports